import { z, ZodType } from 'zod';
import { PlayerVoucherItem, playerVoucherItemSchema } from './player-voucher-item';

export type VoucherItem = {
	currentDeposit: number;
	totalDeposit: number;
	currentWagering: number;
	totalWagering: number;
};

export type Player = {
	id: number;
	name: string;
	balance: number;
	order: number;
	isConnected: boolean;
	voucherItem: PlayerVoucherItem | null;
};

export const voucherItemSchema: ZodType<VoucherItem> = z.object({
	currentDeposit: z.number(),
	totalDeposit: z.number(),
	currentWagering: z.number(),
	totalWagering: z.number(),
});

export const playerSchema: ZodType<Player> = z.object({
	id: z.number(),
	name: z.string(),
	balance: z.number(),
	order: z.number(),
	isConnected: z.boolean(),
	voucherItem: playerVoucherItemSchema.nullable(),
});
